var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "x",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.48,
    height: 23.936,
    viewBox: "0 0 26.48 23.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M104.919,100h4.06l-8.871,10.139,10.436,13.8h-8.171l-6.4-8.368-7.323,8.368H84.587l9.488-10.845L84.064,100h8.379l5.785,7.648Zm-1.425,21.505h2.25L91.221,102.3H88.806Z",
    transform: "translate(-84.064 -100)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/cx.b27efb4d380acd41074f0e5f0e61bb03.svg";
export { ForwardRef as ReactComponent };